import { Contact, CustomerDevice, Device, ServiceItem } from "./Common"
import { JobChecklist } from "./QuoteState"

export interface AvailableJob {
	date?: string,
	start_time?: string,
	device: string,
	description?: string,
	zipcode?: string,
	uuid: string,
	is_completed?: boolean,
	is_job_today?: boolean,
	is_followup?: boolean,
	is_diagnostic?: boolean,
}

export interface AvailableJobsResponseData {
	jobs: AvailableJob[],
	total: number
}

export interface JobsContextItem {
	title: string,
	key: string
}

export enum JobsKeys {
	AVAILABLE ='AVAILABLE',
	ASSIGNED = 'ASSIGNED'
}

export const JobsContext : JobsContextItem[] = [
	{
		title: 'Available Jobs',
		key: JobsKeys.AVAILABLE
	},
	{
		title: 'My Jobs',
		key: JobsKeys.ASSIGNED
	}
]

export enum JobsFilters {
	FOLLOW_UP = 1,
	COMPLETED,
	DIAGNOSTIC
}

export interface JobFilterObject {
	color: string,
	title: string,
	id: JobsFilters
}

export const JobsFiltersOptions: { [key: string]: JobFilterObject } = {
	[JobsFilters.FOLLOW_UP]: {
		color: '#CDDBEF',
		title: 'Follow-up',
		id: JobsFilters.FOLLOW_UP
	},
	[JobsFilters.COMPLETED]: {
		color: '#DEE8D0',
		title: 'Completed',
		id: JobsFilters.COMPLETED
	},
	[JobsFilters.DIAGNOSTIC]: {
		color: '#E0D0E8',
		title: 'Diagnostic',
		id: JobsFilters.DIAGNOSTIC
	}
}

export interface Timeslot {
	id: number,
	date: string,
	start_time: string | number,
	duration: number
}

export interface CurrentJobDetails{
	isTechAssigned: boolean,
	date?: string, // server will not send if not pm
	start_time?: number,
	timeslots: Timeslot[],
	appointment_status_id? : number,
	is_job_today?: boolean,
	is_follow_up?: boolean,
	is_diagnostic?: boolean,
	account_manager: string,
	diagnostic_uuid: string,
}

export interface QuoteListItemService extends ServiceItem{
	price: number,
	payment: number,
}

export interface QuoteListItem {
	services: QuoteListItemService[],
	parts: QuoteListItemService[],
	customer_device_id: number,
	created: string,
	expiration_date: string,
	device: Device,
	price?: number,
	tax?: number
}

export interface CurrentJob {
	uuid: string,
	contact: Contact,
	devices: CustomerDevice[],
	details: CurrentJobDetails
	customerImages: string[],
	technicianImages: string[],
	quoteList: QuoteListItem[],
	checklist: JobChecklist
}

export interface JobsState {
	jobs: AvailableJob[],
	context: JobsContextItem,
	filters: Set<JobsFilters>,
	current_job: CurrentJob | null,
	total_jobs: number
}
